<h1 mat-dialog-title>Paying Steps</h1>
<div mat-dialog-content>Performing this action costs {{steps}} Steps. Are you sure you want to proceed?</div>
<div mat-dialog-actions>
  <button mat-button (click)="doAction()">YES</button>
  <button mat-button mat-dialog-close>NO</button>
</div>
